<template minapp='mpx' xlang='wxml'>
  <view class="es-calendar-week">
    <view
      class="es-calendar-week__item"
      wx:for="{{weeks}}"
      wx:key="*this"
      wx:class="{{{'es-calendar-week__holiday': item === '六' || item === '日'}}}"
    >
      {{ item }}
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  createComponent({
    props: {
      firstDay: {
        type: Number,
        value: 0
      }
    },
    data: {
      weeks: ['日', '一', '二', '三', '四', '五', '六']
    },

    watch: {
      firstDay: {
        immediate: true,
        handler(idx) {
          const week = this.weeks
          this.weeks = week.slice(idx, 7).concat(week.slice(0, idx))
        }
      }
    }
  })
</script>

<style lang='css'>
  .es-calendar-week {
    display: flex;
    line-height: 48px;
    padding: 0 6px;
  }
  .es-calendar-week__item {
    flex: 1;
    font-size: 14px;
    text-align: center;
    font-family: PingFangSC-Regular;
  }

  .es-calendar-week__holiday {
    color: #1473ff;
  }
</style>
<script  type='application/json' lang='json'>
{
 "component": true
}
</script>

